import type { VoidFunctionComponent } from 'react';

import { vendoredMatchFilterOptions } from '../../../../shared/snippets';
import { selectOptionFactory } from '../../../utils';
import { Select } from '../../generic';
import type { VendoredMatchFilterOption } from '../../../../shared/snippets';

export type Props = {
  /**
   * The initial search value.
   */
  initialValues: VendoredMatchFilterOption[];
  /**
   * Callback function to handle debounced changes to the search input.
   */
  onFilterChange: (values: VendoredMatchFilterOption[]) => void;
};

const VendoredMatchFilterLabels: Record<VendoredMatchFilterOption, string> = {
  vendored: 'Vendored Matches',
  exVendored: 'Exclude Vendored Matches',
  converted: 'Manually Converted',
  exConverted: 'Exclude Manually Converted',
};

const vendoredMatchFilterSelectOptions = vendoredMatchFilterOptions.map(
  (option) => selectOptionFactory(option, VendoredMatchFilterLabels[option]),
);

/**
 * This component renders a multi-select dropdown menu for filtering snippets by whether they have
 * a matching vendored dependency or not
 */
const VendoredMatchFilter: VoidFunctionComponent<Props> = ({ initialValues, onFilterChange }) => {
  const values = initialValues.map((value) => selectOptionFactory(value, VendoredMatchFilterLabels[value]));
  return (
    <Select
      id="snippets-vendored-match-filter"
      isMulti
      isClearable
      placeholder="Vendored Matches"
      options={vendoredMatchFilterSelectOptions}
      value={values}
      onChange={(newValues) => onFilterChange(newValues.map((option) => option.value))}
    />
  );
};

export default VendoredMatchFilter;
